import axios from "axios";
import { PORTAL_COMERCIOS } from "../utilities/constants";

// preCupon, int idProducto, int ingresoManual
export const consultarPresentacionesIniciadas = async (preCupon?:number,ingresoManual?:number) => {
    let qs = preCupon ? `?preCupon=${preCupon}&ingresoManual=${ingresoManual}&preOrigen=${PORTAL_COMERCIOS}` : `?ingresoManual=${ingresoManual}&preOrigen=${PORTAL_COMERCIOS}`
    
    return axios.get(`api/Presentaciones/ConsultarPresentacionesIniciadas${qs}`)
}
